<template>
  <div ref="rankingRegionalPage" class="ranking-regional-page">
    <div class="ranking-container">
      <RankingHeader @exportar="exportarRanking" />

      <RankingFilters
        :quadrimestre="quadrimestre"
        :regiao-ibge="regiaoIbge"
        :estado="estado"
        :macro-regiao-saude="macroRegiaoSaude"
        :regiao-saude="regiaoSaude"
        :quadrimestres="quadrimestres"
        :regioes-ibge="regioesIbge"
        :estados="estadosFiltrados"
        :macro-regioes-saude="macroRegioesSaude"
        :regioes-saude="regioesSaude"
        @change-quadrimestre="onChangeQuadrimestre"
        @change-regiao-ibge="onChangeRegiaoIbge"
        @change-estado="onChangeEstado"
        @change-macro-regiao-saude="onChangeMacroRegiaoSaude"
        @change-regiao-saude="onChangeRegiaoSaude"
        @limpar="limparFiltros"
      />

      <div v-if="isLoading" class="loading-card">
        <b-spinner large style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <div v-else>
        <!-- <RankingInfoBox /> -->

        <!-- <RankingColumnInfo :info="info" /> -->

        <RankingTable
          :items="rankingFiltrado"
          :search="search"
          @change-search="search = $event"
          @detalhar="abrirModal"
          @hover-column="updateInfo"
          @abrir-simulador="abrirSimulador"
          @abrir-desempenho="abrirDesempenho"
        />

        <button
          v-show="showBackToTop"
          class="back-to-top-btn"
          @click="scrollToTop"
          title="Voltar ao topo"
        >
          <i class="icofont-long-arrow-up"></i>
        </button>
      </div>

      <RankingDetailsModal
        :visible="modalVisible"
        :municipio="municipioSelecionado"
        :estado="estado"
        :escopo-ranking="{
          regiaoIbge,
          estado,
          macroRegiaoSaude,
          regiaoSaude,
        }"
        @close="fecharModal"
      />

      <ModalSimulador
        v-if="showSimuladorModal"
        :municipio="municipioSimulador"
        @close="fecharSimulador"
      />

      <ModalDesempenho
        :visible="showDesempenhoModal"
        :municipio="municipioDesempenho"
        page="ranking-regional"
        @close="fecharDesempenho"
      />
    </div>
  </div>
</template>

<script>
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

import RankingHeader from '../RankingGeral/components/RankingHeader.vue'
import RankingInfoBox from '../RankingGeral/components/RankingInfoBox.vue'
import RankingSearch from '../RankingGeral/components/RankingSearch.vue'
import RankingTable from '../RankingGeral/components/RankingTable.vue'
import RankingDetailsModal from '../RankingGeral/components/RankingDetailsModal.vue'
import RankingFilters from './components/RankingFilters.vue'
import RankingColumnInfo from '../RankingGeral/components/RankingColumnInfo.vue'
import ModalSimulador from '../RankingGeral/components/ModalSimulador.vue'
import ModalDesempenho from '../RankingGeral/components/ModalDesempenho.vue'

export default {
  name: 'RankingRegional',
  components: {
    RankingHeader,
    RankingInfoBox,
    RankingSearch,
    RankingTable,
    RankingDetailsModal,
    RankingFilters,
    RankingColumnInfo,
    ModalSimulador,
    ModalDesempenho,
  },
  data() {
    return {
      ranking: [],
      search: '',
      quadrimestre: '',
      estado: '',
      info: {
        type: 'ranking',
        title:
          'Passe o mouse sobre uma coluna para visualizar a descrição do indicador ou critério.',
      },
      isLoading: false,
      modalVisible: false,
      municipioSelecionado: null,
      quadrimestres: [],
      showBackToTop: false,
      showSimuladorModal: false,
      municipioSimulador: null,
      regiaoIbge: '',
      macroRegiaoSaude: '',
      regiaoSaude: '',
      regioesIbge: [
        { value: 'Norte', label: 'Norte' },
        { value: 'Nordeste', label: 'Nordeste' },
        { value: 'Centro-Oeste', label: 'Centro-Oeste' },
        { value: 'Sudeste', label: 'Sudeste' },
        { value: 'Sul', label: 'Sul' },
      ],
      estados: [
        { uf: 'AC', region: 'Norte' },
        { uf: 'AL', region: 'Nordeste' },
        { uf: 'AP', region: 'Norte' },
        { uf: 'AM', region: 'Norte' },
        { uf: 'BA', region: 'Nordeste' },
        { uf: 'CE', region: 'Nordeste' },
        { uf: 'DF', region: 'Centro-Oeste' },
        { uf: 'ES', region: 'Sudeste' },
        { uf: 'GO', region: 'Centro-Oeste' },
        { uf: 'MA', region: 'Nordeste' },
        { uf: 'MT', region: 'Centro-Oeste' },
        { uf: 'MS', region: 'Centro-Oeste' },
        { uf: 'MG', region: 'Sudeste' },
        { uf: 'PA', region: 'Norte' },
        { uf: 'PB', region: 'Nordeste' },
        { uf: 'PR', region: 'Sul' },
        { uf: 'PE', region: 'Nordeste' },
        { uf: 'PI', region: 'Nordeste' },
        { uf: 'RJ', region: 'Sudeste' },
        { uf: 'RN', region: 'Nordeste' },
        { uf: 'RS', region: 'Sul' },
        { uf: 'RO', region: 'Norte' },
        { uf: 'RR', region: 'Norte' },
        { uf: 'SC', region: 'Sul' },
        { uf: 'SP', region: 'Sudeste' },
        { uf: 'SE', region: 'Nordeste' },
        { uf: 'TO', region: 'Norte' },
      ],
      showDesempenhoModal: false,
      municipioDesempenho: null,
    }
  },
  computed: {
    estadosFiltrados() {
      if (!this.regiaoIbge) {
        return []
      }

      return this.estados.filter((item) => item.region === this.regiaoIbge)
    },

    macroRegioesSaude() {
      const macros = this.ranking
        .filter((item) => !this.estado || item.uf === this.estado)
        .map((item) => item.macro_regiao_saude)
        .filter(Boolean)

      return [...new Set(macros)].sort()
    },

    regioesSaude() {
      const regionais = this.ranking
        .filter((item) => {
          return (
            (!this.estado || item.uf === this.estado) &&
            (!this.macroRegiaoSaude ||
              item.macro_regiao_saude === this.macroRegiaoSaude)
          )
        })
        .map((item) => item.regiao_saude)
        .filter(Boolean)

      return [...new Set(regionais)].sort()
    },

    /**
     * Retorna o ranking filtrado conforme os filtros selecionados.
     *
     * A ordenação usa a posição original vinda do banco, conforme
     * o escopo selecionado:
     * - Brasil: posicao_br
     * - Região IBGE: posicao_regiao_ibge
     * - UF: posicao_uf
     * - Macro região: posicao_macro_regiao_saude
     * - Região de saúde: posicao_regiao_saude
     *
     * Para macro região e região de saúde, a posição exibida é
     * recalculada após o filtro de escopo, mantendo a sequência
     * visual correta: 1º, 2º, 3º...
     *
     * A busca por nome é aplicada somente depois da posição já
     * definida, portanto ela não recalcula a posição exibida.
     *
     * @returns {Array}
     */
    rankingFiltrado() {
      const termo = this.normalizarTexto(this.search)

      const filtradoPorEscopo = this.ranking.filter((item) => {
        const passaQuadrimestre =
          !this.quadrimestre || item.quadrimestre === this.quadrimestre

        const passaRegiaoIbge =
          !this.regiaoIbge || item.regiao_ibge === this.regiaoIbge

        const passaEstado = !this.estado || item.uf === this.estado

        const passaMacro =
          !this.macroRegiaoSaude ||
          item.macro_regiao_saude === this.macroRegiaoSaude

        const passaRegional =
          !this.regiaoSaude || item.regiao_saude === this.regiaoSaude

        return (
          passaQuadrimestre &&
          passaRegiaoIbge &&
          passaEstado &&
          passaMacro &&
          passaRegional
        )
      })

      const rankingComPosicao = filtradoPorEscopo
        .sort((a, b) => {
          return (
            Number(this.getPosicaoBanco(a) || 999999) -
            Number(this.getPosicaoBanco(b) || 999999)
          )
        })
        .map((item, index) => ({
          ...item,
          posicaoBanco: this.getPosicaoBanco(item),
          posicaoReal:
            this.macroRegiaoSaude || this.regiaoSaude
              ? index + 1
              : this.getPosicaoBanco(item),
        }))

      if (!termo) {
        return rankingComPosicao
      }

      return rankingComPosicao.filter((item) => {
        return this.normalizarTexto(item.municipio).includes(termo)
      })
    },
  },
  watch: {
    quadrimestre() {
      this.carregarRanking()
    },

    regiaoIbge() {
      this.carregarRanking()
    },

    estado() {
      this.carregarRanking()
    },
  },
  mounted() {
    this.carregarQuadrimestres()
    this.$refs.rankingRegionalPage.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    this.$refs.rankingRegionalPage.removeEventListener(
      'scroll',
      this.handleScroll
    )
  },
  methods: {
    /**
     * Retorna a posição original do banco conforme o escopo atual.
     *
     * @param {Object} item Município do ranking.
     * @returns {Number|null}
     */
    getPosicaoBanco(item) {
      if (this.regiaoSaude) {
        return item.posicao_regiao_saude
      }

      if (this.macroRegiaoSaude) {
        return item.posicao_macro_regiao_saude
      }

      if (this.estado) {
        return item.posicao_uf
      }

      if (this.regiaoIbge) {
        return item.posicao_regiao_ibge
      }

      return item.posicao_br
    },

    /**
     * Controla a exibição do botão voltar ao topo.
     *
     * @returns {void}
     */
    handleScroll() {
      this.showBackToTop = this.$refs.rankingRegionalPage.scrollTop > 300
    },

    /**
     * Rola suavemente a página para o topo.
     *
     * @returns {void}
     */
    scrollToTop() {
      this.$refs.rankingRegionalPage.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },

    /**
     * Busca os quadrimestres disponíveis.
     *
     * @returns {Promise<void>}
     */
    async carregarQuadrimestres() {
      const { data } = await this.$apiPublic.get(
        '/cofinanciamento-federal/ranking-geral/quadrimestres'
      )

      const quadrimestres = data.data || []

      this.quadrimestres = quadrimestres.map((item) => ({
        value: item.quadrimestre,
        label: item.quadrimestre,
      }))

      this.quadrimestre = this.quadrimestres[0].value
    },

    /**
     * Busca o ranking APS por filtros opcionais.
     *
     * @returns {Promise<Array>}
     */
    async buscarRankingAps() {
      const { data } = await this.$apiPublic.get(
        '/cofinanciamento-federal/ranking-geral',
        {
          params: {
            quadrimestre: this.quadrimestre || undefined,
            regiao_ibge: this.regiaoIbge || undefined,
            uf: this.estado || undefined,
          },
        }
      )

      return data.data || []
    },

    /**
     * Busca os dados da API e monta o ranking.
     *
     * @returns {Promise<void>}
     */
    async carregarRanking() {
      if (!this.quadrimestre) {
        this.ranking = []
        this.search = ''
        return
      }

      this.isLoading = true

      try {
        const response = await this.buscarRankingAps()

        this.ranking = response
          .map(this.normalizarItemRanking)
          .map((item, index) => {
            let posicao = item.posicao_br

            if (this.regiaoSaude) {
              posicao = item.posicao_regiao_saude
            } else if (this.macroRegiaoSaude) {
              posicao = item.posicao_macro_regiao_saude
            } else if (this.estado) {
              posicao = item.posicao_uf
            } else if (this.regiaoIbge) {
              posicao = item.posicao_regiao_ibge
            }

            return {
              ...item,
              posicaoReal: posicao || index + 1,
            }
          })
      } finally {
        this.isLoading = false
      }
    },

    /**
     * Monta a lista de quadrimestres disponíveis conforme retorno da API.
     *
     * @param {Array} dados Dados retornados pela API.
     * @returns {void}
     */
    montarQuadrimestres(dados) {
      const quadrimestres = [
        ...new Set(dados.map((item) => item.quadrimestre).filter(Boolean)),
      ]

      this.quadrimestres = quadrimestres.map((item) => ({
        value: item,
        label: item,
      }))
    },

    /**
     * Abre o modal de detalhamento.
     *
     * @param {Object} municipio Município selecionado.
     * @returns {void}
     */
    abrirModal(municipio) {
      this.municipioSelecionado = municipio
      this.modalVisible = true
    },

    /**
     * Fecha o modal de detalhamento.
     *
     * @returns {void}
     */
    fecharModal() {
      this.modalVisible = false
      this.municipioSelecionado = null
    },

    /**
     * Normaliza texto para busca sem acentos.
     *
     * @param {string} texto Texto informado.
     * @returns {string}
     */
    normalizarTexto(texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },

    /**
     * Normaliza o item retornado pela API para uso na tabela.
     *
     * @param {Object} item Município retornado pela API.
     * @returns {Object}
     */
    normalizarItemRanking(item) {
      const classificacoes = [
        item.regular,
        item.suficiente,
        item.bom,
        item.otimo,
      ]

      const totalCvat = classificacoes.reduce((total, classificacao) => {
        return (
          total +
          Number(classificacao?.eap_cvat || 0) +
          Number(classificacao?.esf_cvat || 0)
        )
      }, 0)

      const totalGeral = Number(item.equipes_aval_quad || 0) - totalCvat

      return {
        ...item,
        key: `${item.ibge}_${item.quadrimestre}`,
        municipio: item.municipio,
        totalGeral: totalGeral,
        notaGeral: Number(item.desempenho || 0),
        indicadores: Array.isArray(item.indicadores) ? item.indicadores : [],
        desempenhoIndicadores: Number(item.desempenho_indicadores || 0),
        populacao: Number(item.pop_ibge_ano_anterior || 0),
        ied: item.ied || '-',
      }
    },

    /**
     * Exporta o ranking atual para CSV.
     *
     * @returns {void}
     */
    exportarRanking() {
      // console.log('Exportar ranking:', this.ranking)
    },

    /**
     * Atualiza o texto informativo conforme a coluna destacada.
     *
     * @param {string} type Tipo da coluna.
     * @returns {void}
     */
    updateInfo(type) {
      const infos = {
        default:
          'Passe o mouse sobre uma coluna para visualizar a descrição do indicador ou critério.',
        tem: 'Indica se o município possui acesso ou vínculo com o eSUS Feedback.',
        municipio: 'Municípios ordenados conforme os critérios do ranking.',
        regular: 'Percentual de equipes classificadas como Regular.',
        suficiente: 'Percentual de equipes classificadas como Suficiente.',
        bom: 'Percentual de equipes classificadas como Bom.',
        otimo: 'Percentual de equipes classificadas como Ótimo.',
        desempenho: 'Nota geral calculada com pesos por classificação.',
      }

      this.info = {
        type,
        title: infos[type] || infos.default,
      }
    },

    /**
     * Abre o modal do simulador.
     *
     * @param {Object} municipio Município selecionado.
     * @returns {void}
     */
    abrirSimulador(municipio) {
      this.municipioSimulador = municipio
      this.showSimuladorModal = true
    },

    /**
     * Fecha o modal do simulador.
     *
     * @returns {void}
     */
    fecharSimulador() {
      this.showSimuladorModal = false
      this.municipioSimulador = null
    },

    /**
     * Gera o PDF do ranking filtrado.
     *
     * @returns {void}
     */
    gerarPdf() {
      if (!this.rankingFiltrado.length) {
        alert('Nenhum dado disponível para gerar o PDF.')
        return
      }

      const doc = new jsPDF('landscape', 'mm', 'a4')

      const filtroEstado = this.estado || 'Todos os estados'
      const filtroQuadrimestre = this.quadrimestre || 'Todos os quadrimestres'
      const titulo = 'Ranking Resultado Cofinanciamento Federal da APS'

      const headers = [
        'Posição',
        'eSUS Feedback',
        'Município',
        'Regular',
        'Suficiente',
        'Bom',
        'Ótimo',
        'Desempenho',
        // 'Total Equipes',
      ]

      const rows = this.rankingFiltrado.map((item) => [
        `${item.posicaoReal}º`,
        item.tem_esus_feedback ? 'Sim' : 'Não',
        `${item.municipio} - ${item.uf}`,
        item.regular ? this.formatPdfPercent(item.regular.prcntl_eq_aval) : '',
        item.suficiente
          ? this.formatPdfPercent(item.suficiente.prcntl_eq_aval)
          : '',
        item.bom ? this.formatPdfPercent(item.bom.prcntl_eq_aval) : '',
        item.otimo ? this.formatPdfPercent(item.otimo.prcntl_eq_aval) : '',
        Number(item.notaGeral || 0).toFixed(1),
        // item.totalGeral,
      ])

      const dataAtual = new Date().toLocaleDateString('pt-BR')

      doc.setFontSize(14)
      doc.text(titulo, 148, 14, { align: 'center' })

      doc.setFontSize(9)
      doc.text(`Estado: ${filtroEstado}`, 14, 24)
      doc.text(`Quadrimestre: ${filtroQuadrimestre}`, 14, 30)
      doc.text(`Gerado em: ${dataAtual}`, 14, 36)

      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 44,
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 2,
          halign: 'center',
          valign: 'middle',
          lineColor: [217, 226, 236],
          lineWidth: 0.1,
        },
        headStyles: {
          fillColor: [243, 244, 246],
          textColor: [55, 65, 81],
          fontStyle: 'bold',
          lineColor: [209, 213, 219],
          lineWidth: 0.1,
        },
        columnStyles: {
          2: {
            halign: 'left',
            cellWidth: 60,
          },
        },
      })

      doc.save(`ranking-aps-${filtroQuadrimestre}.pdf`)
    },

    /**
     * Formata percentual para exibição no PDF.
     *
     * @param {number|string|null} value Valor percentual.
     * @returns {string}
     */
    formatPdfPercent(value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }

      return `${Number(value).toFixed(1)}%`
    },

    /**
     * Limpa os filtros da tela.
     *
     * @returns {void}
     */
    limparFiltros() {
      this.quadrimestre = this.quadrimestres[0]?.value || ''
      this.regiaoIbge = ''
      this.estado = ''
      this.macroRegiaoSaude = ''
      this.regiaoSaude = ''
      this.search = ''
    },

    /**
     * Atualiza o quadrimestre selecionado.
     *
     * Limpa todos os filtros dependentes, reiniciando a navegação
     * por região, UF, macro região e regional.
     *
     * @param {String} value Quadrimestre selecionado.
     */
    onChangeQuadrimestre(value) {
      this.quadrimestre = value
      this.regiaoIbge = ''
      this.estado = ''
      this.macroRegiaoSaude = ''
      this.regiaoSaude = ''
    },

    /**
     * Atualiza a região do IBGE.
     *
     * Ao alterar a região, os filtros de UF, macro região e regional
     * são reiniciados.
     *
     * @param {String} value Região IBGE selecionada.
     */
    onChangeRegiaoIbge(value) {
      this.regiaoIbge = value
      this.estado = ''
      this.macroRegiaoSaude = ''
      this.regiaoSaude = ''
    },

    /**
     * Atualiza a UF selecionada.
     *
     * Limpa os filtros de macro região e regional.
     *
     * @param {String} value UF selecionada.
     */
    onChangeEstado(value) {
      this.estado = value
      this.macroRegiaoSaude = ''
      this.regiaoSaude = ''
    },

    /**
     * Atualiza a macro região de saúde.
     *
     * Ao alterar a macro região, a regional é reiniciada.
     *
     * @param {String} value Macro região de saúde selecionada.
     */
    onChangeMacroRegiaoSaude(value) {
      this.macroRegiaoSaude = value
      this.regiaoSaude = ''
    },

    /**
     * Atualiza a região de saúde selecionada.
     *
     * @param {String} value Região de saúde selecionada.
     */
    onChangeRegiaoSaude(value) {
      this.regiaoSaude = value
    },

    /**
     * Abre o modal de desempenho.
     *
     * @param {Object} municipio Município selecionado.
     * @returns {void}
     */
    abrirDesempenho(municipio) {
      this.municipioDesempenho = municipio
      this.showDesempenhoModal = true
    },

    /**
     * Fecha o modal de desempenho.
     *
     * @returns {void}
     */
    fecharDesempenho() {
      this.showDesempenhoModal = false
      this.municipioDesempenho = null
    },
  },
}
</script>

<style scoped>
.ranking-regional-page {
  background: #f9fafb;
  height: 100vh;
  overflow-y: auto;
  padding: 24px;
  color: #1f2937;
}

.ranking-container {
  margin: 0 auto;
}

.loading-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px;
  text-align: center;
  color: #6b7280;
}

.back-to-top-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 16px 35px rgba(37, 99, 235, 0.35);
  cursor: pointer;
  z-index: 50;
  transition: 0.2s ease;
  font-size: 30px;
}

.back-to-top-btn:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
}
</style>
